/**
 * Takes an array of size strings a filters them based on max dimensions
 * @private
 * @param {Array<string> sizes - An array of comma delimited size dimensions
 * @param {Array<number>} maxSize - An array containing a max width and height
 * @return {Array<string>} A filtered list of sizes
 */
export default function filterSizes(sizes, [maxWidth = 0, maxHeight = 0]) {
  return sizes.filter((wh) => {
    const [width, height] = wh.split(',').map(v => Number(v));
    if (maxWidth > 0 && width > maxWidth) return false;
    if (maxHeight > 0 && height > maxHeight) return false;
    return true;
  });
}
